import VueRouter from 'vue-router';
import DealerLocator from './views/DealerLocator.vue';

const routes = [
    {
        path: '/dealer-locator',
        name: 'dealer-locator',
        component: DealerLocator,
        props: true,
        meta: {},
    },
];

export default new VueRouter({
    mode: 'history',
    routes,
    base: '/',
    linkActiveClass: 'active',
})